export const SERVICE_BADGES = {
  text_to_image: "Popular",
  product_ad: "High ROI",
  restaurant_ad: "New",
  instagram_post: "Trending",
  youtube_thumbnail: "Essential",
  image_edit: "Tool",
  image_to_image: "Tool",
  background_removal: "Utility",
  background_generation: "Utility",
  upscaling: "Utility",
  variation: "Utility",
  inpainting: "Utility",
};
